import { inject, Injectable } from '@angular/core';
import { AntDataResponse } from '@antony/ng-ui';
import { Observable } from 'rxjs';
import { API_BASE_URL, DeliveryNoteAssignmentApiService, DeliveryNoteAssignmentDto, MailDataDto } from '@api/api.service';
import { ApiResponseUtils } from '@core/api';
import { delay, map } from 'rxjs/operators';
import { DownloadHelper } from '@app/core';

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteAssignmentService {
  private readonly serverUrl = inject(API_BASE_URL);

  constructor(private readonly api: DeliveryNoteAssignmentApiService) {}

  getByVehicleAndDate(vehicleId: number, date: string): Observable<AntDataResponse<DeliveryNoteAssignmentDto>> {
    return this.api.getAllByVehicleAndDate(vehicleId, date).pipe(map(ApiResponseUtils.getAntDataResponseFromResponse));
  }

  create(dto: DeliveryNoteAssignmentDto): Observable<DeliveryNoteAssignmentDto> {
    return this.api.createAssignment(dto).pipe(map(ApiResponseUtils.getDataFromResponse));
  }

  update(resourceId: number, dto: DeliveryNoteAssignmentDto): Observable<DeliveryNoteAssignmentDto> {
    return this.api.updateAssignment(resourceId, dto).pipe(map(ApiResponseUtils.getDataFromResponse));
  }

  delete(resourceId: number): Observable<boolean> {
    return this.api.deleteAssignment(resourceId).pipe(map(ApiResponseUtils.getSuccessFromResponse));
  }

  generateMail(assignmentIds: number[]): Observable<MailDataDto> {
    return this.api.generateMail(assignmentIds).pipe(map((response) => response.data));
  }

  sendMail(mailData: MailDataDto): Observable<void> {
    return this.api.sendMail(mailData);
  }

  downloadMail(assignmentIds: number[]): Observable<void> {
    return this.api.requestMailDownload(assignmentIds).pipe(
      map((response) => DownloadHelper.downloadFromUrl(this.buildDownloadUrlByToken(response.data.token))),
      // this delay is necessary because the above function
      // will open a link in the same tab temporarily
      // otherwise request fired immediately would fail
      delay(200)
    );
  }

  private buildDownloadUrlByToken(token: string): string {
    return `${this.serverUrl}/api/deliveryNotes/assignments/downloadMail?token=${token}`;
  }
}
